import $ from 'jquery';
import _ from 'underscore';
import { anyChecked } from './utilities';
import { isPresent } from '../../utilities/general';
import { setElementsFromScope } from "../../utilities/selectorHelpers";
import EditChecker from '../../components/EditChecker/EditChecker';
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import { SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT } from "../../constants";

export default function walmartReviewTab(wizard) {
  const self = this;
  const wizardElement = wizard.getWizardElement();
  const els = {};

  const elementsMap = {
    walmartPartnerNameReviewTab: ".review-tab-partner-name",
    inventoryStatusMsg: ".inventory-sync-status-msg",
    walmartActiveSince: ".review-tab-active-since",
    walmartPartnerName: "#walmartPartnerNameId",
    sectionTitlesReviewTab: ".section-step-title-inner",
    orderProcessingIcon: "#walmartOrderProcessingCheck",
    walmartInventorySyncingCheck: "#walmartInventorySyncingCheck",
    reviewTabOrderProcessingIcon: ".review-tab-order-processing-icon",
    connectionDescription: "#connection-description",
    orderProcessingStatusYes: ".order-processing-status-yes",
    orderProcessingDateTimeYes: ".order-processing-status-yes-date-time",
    consumerId: "#consumer-id",
    orderProcessingStatusNo: ".order-processing-status-no",
    privateKey: "#private-key",
    startDate: ".start-date",
    timePickerHoursSelect: ".time-picker-hours-select",
    timePickerMinSelect: ".time-picker-minutes-select",
    timePickerPeriodSelect: ".time-picker-period-select",
    inventorySyncYes: ".inventory-sync-status-yes",
    reviewTabTimePickerHoursSelect: ".review-tab-time-picker-hours-select",
    reviewTabTimePickerMinSelect: ".review-tab-time-picker-minutes-select",
    reviewTabTimePickerPeriodSelect: ".review-tab-time-picker-period-select",
    inventorySyncNo: ".inventory-sync-status-no",
    reviewTabDateSetter: ".review-tab-start-date-td",
    reviewTabTimeSetter: ".review-tab-start-time-td",
    privateKeyField: "#privateKey",
    consumerIdField: "#consumerId",
    descriptionField: "#description",
    orderProcessingDateTimeOptionsSelect: ".orderProcessingDateTimeOptions",
    wizardSubmitBtn: ".submit-walmart-connection",
    connAuthDateTime : "#conn-auth-time"
  };


  const retpartner = wizardElement.data("retailer-partners-info");
  const viewChannelDetailUrl = wizardElement.data("view-channel-detail-url");
  const saveChannelUrl = wizardElement.data("save-connection-setup-url");
  const parName=wizardElement.data("par-name");
  const parId = wizardElement.data("partner-id");
  let orderProcessingSelectValue = "";
  const submitModalFlow = new SubmitModalFlow();
  submitModalFlow.init();
  
  self.init = function() {
    setElements();
    bindElements();
    fillChannelsReviewTab();
  };

  self.didNavigateToForm = function () {
    fillChannelsReviewTab();
  };

  function bindElements() {
    els.sectionTitlesReviewTab.bind('click', function () {
      const form = wizardElement.find($(this).data("target-form"));
      wizard.gotToForm(form);
    });
    els.wizardSubmitBtn.on("click", submitBtnHandler);
  }

  function setElements() {
    setElementsFromScope(els, elementsMap, wizardElement);
  }

 /* function setElementsFromScope(targetObj, elementsDict, scope) {
    _(elementsDict).each((v, k) => {
      targetObj[k] = scope.find(v);
    });
  }
*/
  function fillChannelsReviewTab() {
    els.walmartPartnerNameReviewTab.text(els.walmartPartnerName.text());
    els.walmartActiveSince.text(retpartner.repActiveSince);
    els.connectionDescription.text(els.descriptionField.val());
    els.privateKey.text(els.privateKeyField.val());
    els.consumerId.text(els.consumerIdField.val());
    setConfigurationReviewSection();
  }

  function setConfigurationReviewSection() {
    setOrderProcessingOnReviewTab(anyChecked(els.orderProcessingIcon));
    setInventorySyncOnReviewTab(anyChecked(els.walmartInventorySyncingCheck));
    setReviewTabDate();
  }

  function setInventorySyncOnReviewTab(data) {
    if (data) {
      els.inventorySyncYes.show();
      els.inventoryStatusMsg.show();
      els.inventorySyncNo.hide();

    } else {
      els.inventorySyncNo.show();
      els.inventorySyncYes.hide();
      els.inventoryStatusMsg.hide();
    }
  }

  function setOrderProcessingOnReviewTab(data) {
    if (data) {
      els.orderProcessingStatusYes.show();
      els.orderProcessingDateTimeYes.show();
      els.orderProcessingStatusNo.hide();
    } else {
      els.orderProcessingStatusYes.hide();
      els.orderProcessingDateTimeYes.hide();
      els.orderProcessingStatusNo.show();
    }
  }

  function setReviewTabDate() {
    els.reviewTabDateSetter.text(els.startDate.val());
    setReviewTabTime();
    hideShowStartTimeSection();
  }

  function setReviewTabTime() {
    els.reviewTabTimePickerHoursSelect.text(els.timePickerHoursSelect.find("option:selected").val());
    els.reviewTabTimePickerMinSelect.text(els.timePickerMinSelect.find("option:selected").val());
    els.reviewTabTimePickerPeriodSelect.text(els.timePickerPeriodSelect.find("option:selected").val());
  }

  function hideShowStartTimeSection() {
    orderProcessingSelectValue = els.orderProcessingDateTimeOptionsSelect.find(":selected").val();
    
    if ((orderProcessingSelectValue == "future" || orderProcessingSelectValue == "past") ||
             isPresent(els.startDate.val())) {
      els.orderProcessingDateTimeYes.show();
    } else {
      els.orderProcessingDateTimeYes.hide();
    }
  }

  function submitBtnHandler() {

    const submitModalFlow = new SubmitModalFlow({
      confirmModalTitle: "Confirm Connection",
      confirmModalBody: `<div class="q-pad-all-xl">Once you confirm this connection's information, you will be able to begin fulfilling orders from ${parName}</div>`,
      onConfirmClick: function () {
        submitModalFlow.showLoadingModal();
        $.ajax({
          data: {
            consumerId: els.consumerIdField.val(),
            privateKey: els.privateKeyField.val(),
            description: els.descriptionField.val(),
            walmartOrderProcessingCheck: anyChecked(els.orderProcessingIcon),
            startDate: els.startDate.val(),
            startOfOrderProcessingHours: els.timePickerHoursSelect.val(),
            startOfOrderProcessingMinutes: els.timePickerMinSelect.val(),
            startOfOrderProcessingPeriod: els.timePickerPeriodSelect.val(),
            orderProcessingSelectValue: els.orderProcessingDateTimeOptionsSelect.find(":selected").val(),
            walmartInventorySyncingCheck: anyChecked(els.walmartInventorySyncingCheck),
            connAuthDateTime : els.connAuthDateTime.val()
          },
          url: saveChannelUrl,
          dataType: "JSON",
          type: 'POST',
          success: function (data) {
            EditChecker.setPageClean();
            if (parId != "") {
              let detailPageUrl = `${viewChannelDetailUrl}&$&parId=${parId}&$&orgName=${parName}`;
              submitModalFlow.showSuccessModal();
              setTimeout(function () {
                location.href = detailPageUrl;
              }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
            }
            else {
              EditChecker.setPageDirty();
              submitModalFlow.showFailureModal();
            }
          },
          error: function (data) {
            submitModalFlow.hideAllModals();
          }
        });
      }
    });
    submitModalFlow.init();
    submitModalFlow.showConfirmModal();
  }

}



// WEBPACK FOOTER //
// ./src/pages/createChannel/walmartReviewTab.js